'use client'

import { useRouter } from 'next/navigation'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconProfileUserAvatar } from '@redteclab/icons'

import { useOpenableControls } from '../../../generic-hooks'
import { useGlobalConfigContext } from '../../../global-config'
import {
  LoginRegistrationUserLoginModal,
  updateGlobalConfigWithPreferredLanguageAfterLogin,
} from '../../../login-registration'
import { urlResolverGetAccountChangePage } from '../../../url-handling'
import {
  ACCOUNT_HELP_CTA_TYPE,
  CONTACT_PAGE_FS_SCHEMA_CTAS,
} from '../../gtm/model'

import { ContactPageSectionFlatCta } from './ContactPageSectionFlatCta'

export const ContactPageAccountCta: FC<{
  isUserLoggedIn: boolean
}> = ({ isUserLoggedIn }) => {
  const modalControls = useOpenableControls()
  const config = useGlobalConfigContext()
  const router = useRouter()

  const redirectToAccountChangePageAfterLoginWithPreferredLanguage = async (
    afterLoginPromiseWithPreferredLanguage: Promise<string | undefined>,
  ): Promise<void> => {
    const globalConfigWithPreferredLanguage =
      await updateGlobalConfigWithPreferredLanguageAfterLogin(
        config,
        afterLoginPromiseWithPreferredLanguage,
      )
    router.replace(
      urlResolverGetAccountChangePage(globalConfigWithPreferredLanguage),
    )
  }

  return (
    <>
      {isUserLoggedIn ? (
        <ContactPageSectionFlatCta<'a'>
          data-fs-properties-schema={CONTACT_PAGE_FS_SCHEMA_CTAS}
          data-qa-id="qa-id-help-center-account-management"
          data-type={ACCOUNT_HELP_CTA_TYPE}
          href={urlResolverGetAccountChangePage(config)}
          slots={{ root: 'a' }}
          startIcon={
            <IconProfileUserAvatar className="text-dark-primary-max hover:text-dark-brand" />
          }
        >
          <span className="grow whitespace-normal text-start">
            <FormattedMessage id="helpCenter.ordersSection.ctas.account" />
          </span>
        </ContactPageSectionFlatCta>
      ) : (
        <ContactPageSectionFlatCta
          data-qa-id="qa-id-help-center-account-management"
          onClick={modalControls.handleOpen}
          startIcon={
            <IconProfileUserAvatar className="text-dark-primary-max" />
          }
        >
          <FormattedMessage id="helpCenter.ordersSection.ctas.account" />
        </ContactPageSectionFlatCta>
      )}
      <LoginRegistrationUserLoginModal
        afterLoggedIn={(
          afterLoginPromiseWithPreferredLanguage: Promise<string | undefined>,
        ): void => {
          void redirectToAccountChangePageAfterLoginWithPreferredLanguage(
            afterLoginPromiseWithPreferredLanguage,
          )
        }}
        onClose={modalControls.handleClose}
        open={modalControls.isOpen}
      />
    </>
  )
}
